import { BOGGLE_COMMON_LETTER_VALUES } from '~/boggle/config/challengeModLetterConstants'
import type { BoggleChallengeBoardDistributionDefinition } from '~/boggle/config/boardDistributions/boardDistributionDefinition'
import type { BoggleResolvedChallengeBoardDistribution } from '~/boggle/config/challenges/modTypes'
import { formatResolvedBoardDistributionDisplayFromDefinition } from '~/boggle/config/boardDistributions/formatResolvedBoardDistributionDisplay'
import { COMMON_ALLOWED_LETTERS } from '~/boggle/lib/challenge/parameterVariants'

export const commonConsonantsOnlyBoardDistributionDefinition: BoggleChallengeBoardDistributionDefinition =
  {
    description: 'Only common consonants appear',
    id: 'common-consonants-only',
    name: 'Only Common Consonants',
    parameterDefinitions: {
      consonants: {
        itemValues: BOGGLE_COMMON_LETTER_VALUES,
        kind: 'string-list',
        max: BOGGLE_COMMON_LETTER_VALUES.length,
        min: BOGGLE_COMMON_LETTER_VALUES.length,
      },
    },
    selectionWeight: 1,
    shortLabel: 'TLRNS + vowels',
  }

export function resolveCommonConsonantsOnlyBoardDistribution(
  family: BoggleChallengeBoardDistributionDefinition,
  rngState: number,
): {
  mod: BoggleResolvedChallengeBoardDistribution
  rngState: number
} {
  const parameters = {
    consonants: {
      definition: family.parameterDefinitions.consonants!,
      value: BOGGLE_COMMON_LETTER_VALUES,
    },
  }
  const display = formatResolvedBoardDistributionDisplayFromDefinition(family, parameters)

  return {
    mod: {
      description: display.description,
      effects: [
        {
          kind: 'letter-weights',
          transform: {
            kind: 'restrict-letter-set',
            letters: COMMON_ALLOWED_LETTERS,
          },
        },
      ],
      familyId: family.id,
      id: family.id,
      name: display.name,
      outcomes: [],
      parameters,
      shortLabel: display.shortLabel,
    },
    rngState,
  }
}
